import axios from 'axios'
import { AppThunk } from '../../store';
import { clearAuth, setAuth, setErrorMessage,clearErrorMessage } from './authSlice';
import { AuthQuery, AuthReply } from './authTypes';
import { backendURL } from '../../../constants';

export const login = (credentials: AuthQuery): AppThunk => async (dispatch) => {
    try {
        dispatch(clearErrorMessage());
        const response = await axios.post(backendURL + "/auth/authenticate", credentials);
        const reply: AuthReply = response.data;
        if (reply.isLogged) {
            dispatch(setAuth(reply));
        }
        else
            dispatch(setErrorMessage('Invalid credentials.'));
    } catch (error: any) {
        dispatch(setErrorMessage(error.message || 'Invalid credentials.'));
    }
};

export const tokenLogin = (token: string, requestedRole: string): AppThunk => async (dispatch) => {
    try {
        var config = {
            headers: { Authorization: "Bearer " + token }
          };
        const response = await axios.get(backendURL + "/auth/validate/"+requestedRole, config);
        const reply: AuthReply = response.data;
        dispatch(setAuth(reply));
    } catch (error: any) {
        dispatch(setErrorMessage(error.message || 'Invalid credentials.'));
    }
};

export const logout = (): AppThunk => async (dispatch) => {
    dispatch(clearAuth());
};

export const changePassword = (credentials: AuthQuery): AppThunk => async (dispatch) => {
    try {
        const response = await axios.post(backendURL + "/auth/password", credentials);
        const reply: AuthReply = response.data;
        dispatch(setAuth(reply));
    } catch (error: any) {
        dispatch(setErrorMessage(error.message || 'Invalid credentials.'));
    }
};

export const resetPassword = (email: string): AppThunk => async (dispatch) => {
    try {
        const response = await axios.post(backendURL + "/auth/lost", {Value: email});
        dispatch(setErrorMessage("Reset link sent."));
    } catch (error: any) {
        dispatch(setErrorMessage(error.message || 'Invalid credentials.'));
    }
};